module.exports = __webpack_public_path__ + "9a71f0e92ca6382b78c1ec6c8c45fe00.png";